import {useState} from "react";
import {useHistory} from "react-router-dom";

export type PaginationParamProps = {
    page?: number;
    linesPerPage?: string | number;
    orderBy?: string;
    direction?: string;
}


export const usePaginationFilters = (
    history: ReturnType<typeof useHistory>,
    initialFilters: PaginationParamProps = {
        page: 0,
        linesPerPage: 10,
        orderBy: 'id',
        direction: 'DESC'
    }
) => {
    const [filters, setFilters] = useState<PaginationParamProps>(initialFilters);

    const updateFilters = (newFilters: PaginationParamProps) => {
        setFilters(prevState => ({...prevState, ...newFilters}))
    };


    const resetPaginationFilters = () => {
        setFilters({
            page: 0,
            linesPerPage: 10,
            orderBy: 'id',
            direction: 'DESC'
        });
    }

    return [filters, updateFilters, resetPaginationFilters] as const;
};


type BodyFilters = {
    [key: string]: any | undefined;
};

type UpdateFilterProps = {
    displayField?: any,
    isArrayValue?: boolean,
    putOnUrl?: boolean,
    property: string,
    value: any,
}

const updateURL = (history: ReturnType<typeof useHistory>, property: string, value: any) => {
    const queryParams = new URLSearchParams(history.location.search);
    queryParams.set(property, value);

    history.push({
        search: queryParams.toString(),
    });
};

const clearURLParams = (history: ReturnType<typeof useHistory>) => {
    const urlSearchParams = new URLSearchParams(history.location.search);
    const typeParam = urlSearchParams.get('type');
    urlSearchParams.delete('type');
    history.push({
        pathname: history.location.pathname,
        search: typeParam ? `?type=${typeParam}` : '', // Recria a string de consulta mantendo 'type'
    });
};

export const useBodyFilter = (initialFilters: BodyFilters = {}) => {
    const [filters, setFilters] = useState<BodyFilters>(initialFilters);
    const history = useHistory();
    const updateFilters = (
        {
            displayField,
            isArrayValue,
            property,
            value,
            putOnUrl,
        }: UpdateFilterProps) => {
        setFilters((prevFilters) => {
            if (isArrayValue && Array.isArray(prevFilters[property])) {
                if (prevFilters[property].includes(value)) {
                    return prevFilters;
                } else {
                    return {...prevFilters, [property]: [value]};
                }
            } else {
                return {...prevFilters, [property]: isArrayValue ? [value] : value};
            }
        });

        if (putOnUrl) {
            updateURL(history, property, displayField ? value?.[displayField] : value)
        }
    };


    const resetFilters = () => {
        clearURLParams(history);
        setFilters({});
    };

    return [filters, updateFilters, resetFilters] as const;
}